/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Photo_DuoInputs */

const en_directory_ai_tools_studio_photo_duo = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_DuoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo 2 · Your duo`)
};

const zh_directory_ai_tools_studio_photo_duo = /** @type {(inputs: Directory_Ai_Tools_Studio_Photo_DuoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照片 2 · 你的搭档`)
};

/**
* | output |
* | --- |
* | "Photo 2 · Your duo" |
*
* @param {Directory_Ai_Tools_Studio_Photo_DuoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_photo_duo = /** @type {((inputs?: Directory_Ai_Tools_Studio_Photo_DuoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Photo_DuoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_photo_duo(inputs)
	return zh_directory_ai_tools_studio_photo_duo(inputs)
});
export { directory_ai_tools_studio_photo_duo as "directory.ai_tools.studio.photo_duo" }